import type { VacationResponse } from './types';

const PATH = '/api/controls/vacation';

// Cookie-based auth (zelfde patroon als reserveLock.ts / evHint.ts):
// credentials:'include' stuurt zbs_session mee. Backend accepteert ook
// X-API-Key, maar de browser-frontend gebruikt uitsluitend cookies.

export async function fetchVacationState(): Promise<VacationResponse> {
  const res = await fetch(PATH, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    let body = '';
    try { body = await res.text(); } catch { /* ignore */ }
    throw new Error(`GET ${PATH}: ${res.status} ${body.slice(0, 200)}`);
  }
  return await res.json() as VacationResponse;
}

export interface StartVacationOpts {
  /** ISO date 'YYYY-MM-DD' of full ISO datetime. */
  endDate: string;
  /** SOC-floor tijdens vacation; backend valideert 5..20. Default backend = 5. */
  socMinPct: number;
}

export async function startVacation(opts: StartVacationOpts): Promise<VacationResponse> {
  const res = await fetch(`${PATH}/start`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      end_date: opts.endDate,
      soc_min_pct: opts.socMinPct,
    }),
  });
  if (!res.ok) {
    let detail = '';
    try {
      const j = await res.json() as { detail?: string };
      detail = j.detail ?? '';
    } catch {
      try { detail = await res.text(); } catch { /* ignore */ }
    }
    throw new Error(`POST ${PATH}/start: ${res.status} ${detail.slice(0, 200)}`);
  }
  return await res.json() as VacationResponse;
}

export async function stopVacation(): Promise<void> {
  const res = await fetch(`${PATH}/stop`, {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    let body = '';
    try { body = await res.text(); } catch { /* ignore */ }
    throw new Error(`POST ${PATH}/stop: ${res.status} ${body.slice(0, 200)}`);
  }
}
